/**
 * Structured data generation functionality
 * @module structured-data
 */

/**
 * Generates structured data for listicle content
 */
export function generateListicleStructuredData() {
  const container = document.querySelector('.wp-block-kbs-listicle');
  if (!container) return;

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    'itemListElement': generateListItems(container)
  };

  injectStructuredData(structuredData);
}

function generateListItems(container) {
  return Array.from(container.querySelectorAll('.wp-block-kbs-listicle-item'))
              .map((item, index) => {
                const title = item.querySelector('.listicle-item__title')?.textContent.trim();
                const subitems = getSubitems(item);

                const itemData = {
                  '@type': 'ListItem',
                  'position': index + 1,
                  'name': title
                };

                if (subitems.length) {
                  itemData.itemListElement = generateSubitems(subitems);
                }

                return itemData;
              });
}

function getSubitems(item) {
  return Array.from(item.querySelectorAll('.listicle-item__content p'))
              .map(p => p.textContent.trim())
              .filter(Boolean);
}

function generateSubitems(subitems) {
  return subitems.map((subitem, index) => ({
    '@type': 'ListItem',
    'position': index + 1,
    'name': subitem
  }));
}

function injectStructuredData(data) {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}
